/* Neriela v2: scroll reveal, video reel, welcome popup. No dependencies. */
(function () {
  'use strict';
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  /* ---------- v2: reveal on scroll ---------- */
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal(root) {
    if (reduceMotion || !('IntersectionObserver' in window)) return;
    var selectors = [
      'main .section .row-between', 'main .section h2.display', 'main .section .lede',
      'main .grid > *', 'main .reel > *', 'main .women-grid > *', 'main .symbols > *',
      'main .split > *', 'main .feature', 'main .tile', 'main .qa', 'main .lifestyle__card',
      'main .story-card', 'main .faq', 'main .center-stack > *'
    ];
    var nodes = $$(selectors.join(','), root).filter(function (el) {
      return !el.closest('.hero') && !el.hasAttribute('data-reveal') && !el.closest('[data-reveal]');
    });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    nodes.forEach(function (el) {
      var parent = el.parentElement;
      var idx = parent ? Array.prototype.indexOf.call(parent.children, el) : 0;
      el.style.setProperty('--reveal-delay', Math.min(idx, 6) * 0.07 + 's');
      el.setAttribute('data-reveal', '');
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight * 0.92) { el.classList.add('is-in'); }
      else { io.observe(el); }
    });
  }

  /* ---------- v2: video reel plays only while visible ---------- */
  function initReels(root) {
    var videos = $$('[data-reel-video]', root);
    if (!videos.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) {
          if (!v.dataset.loaded) {
            $$('source[data-src]', v).forEach(function (src) { src.src = src.getAttribute('data-src'); });
            v.load();
            v.dataset.loaded = '1';
          }
          var p = v.play();
          if (p && p.then) p.then(function () { v.classList.add('is-playing'); }).catch(function () {});
          else v.classList.add('is-playing');
        } else if (!v.paused) {
          v.pause();
        }
      });
    }, { threshold: 0.35 });
    videos.forEach(function (v) {
      v.addEventListener('playing', function () { v.classList.add('is-playing'); });
      io.observe(v);
    });
  }

  /* ---------- v2: welcome popup (first name + email) ---------- */
  function store(key, val) {
    try { if (val === undefined) return window.localStorage.getItem(key); window.localStorage.setItem(key, val); } catch (e) { return null; }
    return null;
  }

  function initWelcomePopup() {
    var pop = $('[data-nl-pop]');
    if (!pop) return;
    var KEY = 'neriela-welcome-dismissed';
    var justPosted = window.location.hash === '#PopupNewsletter' || (/customer_posted=true/.test(window.location.search) && $('[data-nl-success]', pop));
    function open() {
      if (!pop.hidden) return;
      pop.hidden = false;
      requestAnimationFrame(function () { pop.classList.add('is-open'); });
      window.removeEventListener('scroll', onScroll);
    }
    function close() {
      pop.classList.remove('is-open');
      store(KEY, String(Date.now()));
      setTimeout(function () { pop.hidden = true; }, 400);
    }
    $$('[data-nl-close]', pop).forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !pop.hidden) close(); });
    if (justPosted) { open(); store(KEY, String(Date.now())); return; }
    var last = parseInt(store(KEY) || '0', 10);
    if (last && Date.now() - last < 14 * 864e5) return;
    var delay = parseInt(pop.getAttribute('data-delay') || '20', 10) * 1000;
    function onScroll() {
      var h = document.documentElement.scrollHeight - window.innerHeight;
      if (h > 0 && window.scrollY / h > 0.5) open();
    }
    setTimeout(open, delay);
    window.addEventListener('scroll', onScroll, { passive: true });
  }


  function boot() { initReveal(document); initReels(document); initWelcomePopup(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { initReels(e.target); });
})();
